import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { inr, inrCompact, fmtDate } from "@/lib/format";
import { PageHeader } from "@/components/PageHeader";
import { KpiCard } from "@/components/KpiCard";
import { StatusBadge } from "@/components/StatusBadge";
import { Wallet, CheckCircle, Clock } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Payouts() {
  const [payouts, setPayouts] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/payouts").then(({ data }) => setPayouts(data)); }, []);

  const totalNet = payouts.reduce((a, b) => a + b.net_payable, 0);
  const paid = payouts.filter((p) => p.status === "Paid").reduce((a, b) => a + b.net_payable, 0);
  const pending = payouts.filter((p) => p.status !== "Paid").reduce((a, b) => a + b.net_payable, 0);

  return (
    <div>
      <PageHeader title="Payouts" subtitle="Gross earnings, deductions & net payable statements" />
      <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
        <KpiCard testId="payout-total" label="Total Net Payable" value={inrCompact(totalNet)} icon={Wallet} accent="primary" />
        <KpiCard testId="payout-paid" label="Paid" value={inrCompact(paid)} icon={CheckCircle} accent="emerald" />
        <KpiCard testId="payout-pending" label="Pending" value={inrCompact(pending)} icon={Clock} accent="amber" />
      </div>
      <div className="overflow-hidden rounded-xl border border-border bg-card">
        <Table>
          <TableHeader><TableRow className="hover:bg-transparent"><TableHead>DP</TableHead><TableHead>Period</TableHead><TableHead className="text-right">Gross</TableHead><TableHead className="text-right">EV Rent</TableHead><TableHead className="text-right">Net Payable</TableHead><TableHead>Date</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
          <TableBody>
            {payouts.map((p) => (
              <TableRow key={p.id} className="cursor-pointer" onClick={() => nav(`/dp/${p.dp_id}`)} data-testid={`payout-row-${p.id}`}>
                <TableCell className="font-semibold">{p.dp_name}</TableCell><TableCell>{p.period}</TableCell>
                <TableCell className="text-right tabular">{inr(p.gross)}</TableCell><TableCell className="text-right tabular text-rose-500">-{inr(p.ev_rent)}</TableCell>
                <TableCell className="text-right tabular font-bold text-emerald-500">{inr(p.net_payable)}</TableCell><TableCell>{fmtDate(p.date)}</TableCell><TableCell><StatusBadge status={p.status} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
